/**
 * Curated tests for the anonymous landing-page demo.
 *
 * IMPORTANT: this list is shared between client (InlineDemo) and server
 * (api.demo-evaluate). The server validates that the submitted `test` is
 * one of these strings before calling OpenAI, so an attacker can't pass
 * arbitrary prompt content through the demo endpoint.
 */
export const DEMO_TESTS: readonly string[] = [
  "You're not really my type tbh.",
  "Wait, how old are you again?",
  "lol you give off serial dater vibes.",
  "I bet you say that to every girl.",
  "You seem like the kind of guy who lives with his mom.",
  "You always this confident or just trying to impress me?",
  "Bet you wouldn't last 10 minutes with me.",
] as const;

export const isDemoTest = (s: string): boolean =>
  DEMO_TESTS.includes(s as (typeof DEMO_TESTS)[number]);
